var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'system_month_payer_group', params: {groupYearMonth: _vm.groupYearMonth}}}},[_vm._v("\n  "+_vm._s(_vm.groupYearMonth)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }